import React, { useState } from 'react';
import { METHODTYPE } from '../components/constants';
import Swal from 'sweetalert2'
import { Modal, Grid, Card, CardContent, Typography, Box } from '@material-ui/core';
import { DESERVER_STATUS_GROUPS } from './constants';
import { useTranslation } from "react-i18next";

const serverUrl = process.env.REACT_APP_SERVER_URL;
const ig2 = "/img/ig2.png";
const tt2 = "/img/tt2.png";

const UserProductBox = ({
  product,
  auth0AccessToken
}) => {

  const today = new Date().toISOString().split('T')[0];

  const { t } = useTranslation();
  const getStatusDisplayValue = (statusCode) => {
    const groupKey = Object.entries(DESERVER_STATUS_GROUPS).find(
      ([, codes]) => codes.includes(statusCode)
    )?.[0];

    if (!groupKey) return "";

    return t(`deserve_status.${groupKey}`); // e.g. deserve_status.DESERVED
  };
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-outline-warning",
      cancelButton: "btn btn-outline-warning"
    },
    buttonsStyling: false
  });

  const posted = async (appType) => {
    try {
      const token = auth0AccessToken;
      var bodyRequest = JSON.stringify({
        "appType": appType,
      });
      const response = await fetch(
        `${serverUrl}/api/deserves/${product.idProduct}/shared`,
        {
          method: METHODTYPE.PUT,
          body: bodyRequest,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response.json();

      if (appType == "facebook") {
        await shareOnFacebookUsingSDK();
      } else if (appType == "x") {
        sharePostOnX();
      } else if (appType == "linkedin") {
        sharePostOnLinkedIn();
      }

      //if (appType != "facebook") {
        window.location.reload();
      //}
    } catch (error) {
      swalWithBootstrapButtons.fire({
        title: "Oops...",
        text: error.message,
        icon: "error"
      });
    }

  }

  const updateDeservePostUrl = async (idProduct, postUrl) => {
    try {
      const token = auth0AccessToken;
      var bodyRequest = JSON.stringify({
        "postUrl": postUrl,
      });
      const response = await fetch(
        `${serverUrl}/api/deserves/${idProduct}/review`,
        {
          method: METHODTYPE.PUT,
          body: bodyRequest,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      swalWithBootstrapButtons.fire({
        title: "Oops...",
        text: error.message,
        icon: "error"
      });
    }
    window.location.reload();
  }

  const removeFromDeserves = async (product) => {
    try {
      const token = auth0AccessToken;
      const response = await fetch(
        `${serverUrl}/api/deserves/${product.idProduct}`,
        {
          method: METHODTYPE.DELETE,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response.json();
      //history.push("/deserves");
    } catch (error) {
      swalWithBootstrapButtons.fire({
        title: "Oops...",
        text: error.message,
        icon: "error"
      });
    }
  }

  const socialMedia = [
    { name: "facebook", icon: "facebook.svg", type: "1" },
    { name: "instagram", icon: "instagram.svg", type: "2", onClick: "shareOnInstagram" },
    { name: "x", icon: "x.svg", type: "3" },
    { name: "tiktok", icon: "tiktok.svg", type: "4", onClick: "shareOnTikTok" },
    { name: "linkedin", icon: "linkedin.svg", type: "5" }
  ];

  const handleClick = (event, platform) => {
    if (platform === "instagram") {
      shareOnInstagram();
    } else if (platform === "tiktok") {
      shareOnTikTok();
    } else {
      sharePost(event, platform);
    }
  };

  return (
    <Grid item xs={12} sm={6} md={3} style={{ marginBottom: '20px' }}> {/* Responsive layout */}
      <Card variant="outlined" style={{ borderTop: "3px solid #EBBB5B", height: '100%' }}>
        <CardContent style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
          <Box textAlign="center" mb={2}>
            <img
              src={product.imageUrl}
              alt="Loading..."
              height="75px"
            />
          </Box>

          <Typography variant="h5" component="h3" align="center">
            {product.name}
          </Typography>

          <Typography variant="body2" color="textSecondary" align="center" style={{ minHeight: '60px' }}>
            {product.details}
          </Typography>

          <ul className="list-group list-group-unbordered mb-3">
            <li className="list-group-item">
              <b>{'Status'}</b>
              <span className="float-right">{getStatusDisplayValue(product.status)}</span>
            </li>
            <li className="list-group-item">
              <b>{'Homepage'}</b>
              <span className="float-right">
                <a href={product.homePage} target="_blank" rel="noopener noreferrer">{product.companyName}</a>
              </span>
            </li>
            <li className="list-group-item">
              <b>{'Benötigte Likes'}</b>
              <span className="float-right">{product.price}</span>
            </li>
            <li className="list-group-item">
              <b>{'Start'}</b>
              <span className="float-right">{new Date(product.createdts).toLocaleDateString('de-DE')}</span>
            </li>
            <li className="list-group-item">
              <b>{'Ende'}</b>
              <span className="float-right">{new Date(product.expirationDate).toLocaleDateString('de-DE')}</span>
            </li>

            {/* {product.expirationDate >= today && product.status === 1 &&
                            (
                                <li className="list-group-item" style={{ height: '60px' }}>
                                    <div className="text-center">
                                        <div style={{ display: 'inline-block', position: 'relative' }}>
                                            <img
                                                onClick={(event) => sharePost(event, "facebook")}
                                                className="svg32 pointer"
                                                src="img/facebook.svg"
                                                height="25px"
                                                alt="Facebook"
                                                title="Facebook"
                                            />
                                            {
                                                product.appType && product.appType.includes("1") && (
                                                    <img
                                                        src="img/favicon.png"
                                                        height="10px"
                                                        alt="deserved"
                                                        title="deserved"
                                                        style={{ position: 'absolute', bottom: '-15px', left: '50%', transform: 'translateX(-50%)' }}
                                                    />
                                                )
                                            }
                                        </div>
                                        <span style={{ display: 'inline-block', width: '20px' }} />
                                        <div style={{ display: 'inline-block', position: 'relative' }}>
                                            <img
                                                onClick={shareOnInstagram}
                                                className="svg32 pointer"
                                                src="img/instagram.svg"
                                                height="25px"
                                                alt="Instagram"
                                                title="Instagram"
                                            />
                                            {
                                                product.appType && product.appType.includes("2") && (
                                                    <img
                                                        src="img/favicon.png"
                                                        height="10px"
                                                        alt="deserved"
                                                        title="deserved"
                                                        style={{ position: 'absolute', bottom: '-15px', left: '50%', transform: 'translateX(-50%)' }}
                                                    />
                                                )
                                            }
                                        </div>
                                        <span style={{ display: 'inline-block', width: '20px' }} />
                                        <div style={{ display: 'inline-block', position: 'relative' }}>
                                            <img
                                                onClick={(event) => sharePost(event, "x")}
                                                className="svg32 pointer"
                                                src="img/x.svg"
                                                height="25px"
                                                alt='X'
                                                title='X'
                                            />
                                            {
                                                product.appType && product.appType.includes("3") && (
                                                    <img
                                                        src="img/favicon.png"
                                                        height="10px"
                                                        alt="deserved"
                                                        title="deserved"
                                                        style={{ position: 'absolute', bottom: '-15px', left: '50%', transform: 'translateX(-50%)' }}
                                                    />
                                                )
                                            }
                                        </div>
                                        <span style={{ display: 'inline-block', width: '20px' }} />
                                        <div style={{ display: 'inline-block', position: 'relative' }}>
                                            <img
                                                onClick={shareOnTikTok}
                                                className="svg32 pointer"
                                                src="img/tiktok.svg"
                                                height="25px"
                                                alt="Instagram"
                                                title="Instagram"
                                            />
                                            {
                                                product.appType && product.appType.includes("4") && (
                                                    <img
                                                        src="img/favicon.png"
                                                        height="10px"
                                                        alt="deserved"
                                                        title="deserved"
                                                        style={{ position: 'absolute', bottom: '-15px', left: '50%', transform: 'translateX(-50%)' }}
                                                    />
                                                )
                                            }
                                        </div>
                                        <span style={{ display: 'inline-block', width: '20px' }} />
                                        <div style={{ display: 'inline-block', position: 'relative' }}>
                                            <img
                                                onClick={(event) => sharePost(event, "linkedin")}
                                                className="svg32 pointer"
                                                src="img/linkedin.svg"
                                                height="25px"
                                                alt='Linkedin'
                                                title='Linkedin'
                                            />
                                            {
                                                product.appType && product.appType.includes("5") && (
                                                    <img
                                                        src="img/favicon.png"
                                                        height="10px"
                                                        alt="deserved"
                                                        title="deserved"
                                                        style={{ position: 'absolute', bottom: '-15px', left: '50%', transform: 'translateX(-50%)' }}
                                                    />
                                                )
                                            }
                                        </div>
                                    </div>
                                </li>
                            )} */}

            {product.expirationDate >= today && product.status === 1 &&
              (
                <li className="list-group-item">
                  <div className="social-container">
                    {socialMedia.map(({ name, icon, type }) => (
                      <div key={name} className="social-item">
                        <img
                          onClick={(event) => handleClick(event, name)}
                          className="svg32 pointer social-icon"
                          src={`img/${icon}`}
                          height="25px"
                          alt={name}
                          title={name.charAt(0).toUpperCase() + name.slice(1)}
                        />
                        {product.appType?.includes(type) && (
                          <img
                            src="img/favicon.png"
                            height="10px"
                            alt="deserved"
                            title="deserved"
                            className="small-icon"
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </li>
              )}
          </ul>

          {product.status === 6 && (
            <button
              id={product.idProduct + "closed"}
              className="btn btn-outline-warning"
              block="true"
              onClick={() => {
                complete();
                swalWithBootstrapButtons.fire({
                  title: "Abgeschlossen!",
                  text: "Gratulation zum erfolgreichen Abschliessen!",
                  icon: "success"
                }).then(() => {
                  window.location.reload();
                });
              }}
            >
              Abschliessen
            </button>
          )}

          {product.expirationDate >= today && product.status === 1 && (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <button
                //id={product.idProduct}
                className="btn btn-outline-warning col-md-6"
                onClick={() => {
                  swalWithBootstrapButtons.fire({
                    title: "Bist Du sicher, dass Du das Produkt nicht mehr deserven möchtest?",
                    text: "Deine bereits gesammelten Likes gehen somit verloren!",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonText: "Ja, entfernen!",
                    cancelButtonText: "Nein, abbrechen!",
                    //reverseButtons: true'
                  }).then((result) => {
                    if (result.isConfirmed) {
                      removeFromDeserves(product)
                      swalWithBootstrapButtons.fire({
                        title: "Entfernt!",
                        text: "Dein deserve wurde entfernt.",
                        icon: "success"
                      }).then(() => {
                        window.location.reload();
                      });
                    }
                  });
                }}

              >
                {'Entfernen'}
              </button>

              <button
                id={product.idProduct + "reached"}
                className="btn btn-outline-warning col-md-6"
                block="true"
                onClick={() => {
                  swalWithBootstrapButtons.fire({
                    title: "Melde uns Deinen Erfolg",
                    icon: "info",
                    text: "Trage hier den Link zu Deinem Post auf der Social-Media-Plattform ein. " +
                      "Eine Schritt-für-Schritt-Anleitung, wie Du den Link findest, findest Du im Abschnitt „So funktioniert's“.",
                    input: 'text',
                    showCancelButton: true,
                    closeOnConfirm: false,
                    confirmButtonText: "Bestätigen",
                    cancelButtonText: "Abbrechen",
                    inputPlaceholder: "Link hier eintragen!",

                    inputValidator: (value) => {
                      if (!value.includes("https://")) {
                        return "Die Eingabe ist ungültig.";
                      }
                    }
                  }).then((result) => {
                    if (result.isDismissed) return false; // falls der Benutzer abbricht
                    const inputValue = result.value;

                    if (inputValue === "") {
                      swalWithBootstrapButtons.fire({
                        icon: 'error',
                        title: 'Fehler!',
                        text: 'Du musst einen Link eintragen!'
                      });
                      return false;
                    }

                    swalWithBootstrapButtons.fire({
                      icon: 'success',
                      title: 'Perfekt!',
                      text: `Du hast den Link eingetragen. Wir werden diesen prüfen und melden uns wieder bei Dir.`
                    }).then(() => {
                      updateDeservePostUrl(product.idProduct, inputValue);

                    });
                  });
                }}
              >
                Erfolg melden
              </button>
            </div>
          )}
        </CardContent>
      </Card>
    </Grid>

  );

  function sharePostOnLinkedIn(e) {
    const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(product.homePage)}`;
    openWindowPopup(linkedInUrl, "LinkedInShare");
  }

  function sharePostOnX(e) {
    const postUrl = encodeURIComponent(product.homePage);
    const hashtags = "mydeserve"; // Hashtags without #
    const xUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(product.name + "\n\n")}&url=${postUrl}&hashtags=${hashtags}&via=${"app.mydeserve.ch"}`;
    openWindowPopup(xUrl, "XShare");
  }

  function openWindowPopup(popupUrl, popuptitle) {
    // Calculate center position
    const width = 800;
    const height = 600;

    // Get screen size and calculate center position
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || window.screen.width;
    const screenHeight = window.innerHeight || document.documentElement.clientHeight || window.screen.height;

    const left = (screenWidth - width) / 2 + window.screenX;
    const top = (screenHeight - height) / 2 + window.screenY;
    // Open a centered popup window
    const popup = window.open(
      popupUrl,
      popuptitle,
      `width=${width},height=${height},top=${top},left=${left},toolbar=no,menubar=no,scrollbars=yes,resizable=no`
    );

    // Focus on the new window
    if (popup) {
      popup.focus();
    }
  }

  function getAppName(appType) {
    return appType.replace(/^./, function (char) { return char.toUpperCase(); });
  }

  function sharePost(event, appType) {
    swalWithBootstrapButtons.fire({
      title: "Auf " + getAppName(appType) + " teilen",
      text: "Möchtest du den deserve auf " + getAppName(appType) + " teilen?",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Ja, teilen!",
      cancelButtonText: "Nein, abbrechen!",
      //reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        event.preventDefault();
        posted(appType);
      }
    });
  }

  async function shareOnFacebookUsingSDK() {
    /****************START : Using FACEBOOK INTERNAL SDK*********/
    //http://waterheatertimer.org/How-to-add-facebook-share-pop-up-window-to-website.html
    var rawPostHashtags = "#mydeserve"; // Replace with your desired hashtags
    //DOC: https://developers.facebook.com/docs/javascript/reference/FB.ui
    //PARAMS: https://developers.facebook.com/docs/sharing/reference/share-dialog
    window.FB.ui({
        method: "share",
        href: product.homePage,
        hashtag: rawPostHashtags,
        display: window.innerWidth <= 768 ? "touch" : "popup",
    },
        // callback
        function (response) {
            //Response from facebook
            if (response && !response.error_message) {
                //console.log('Posting completed.');
            } else {
                console.error('Error while posting.');
            }
        }
    );

    /****************END : Using FACEBOOK INTERNAL SDK*********/

    return;


    const postHashtags = encodeURIComponent("#mydeserve");
    const shareUrl = encodeURIComponent(product.homePage);
    const shareDialogUrl = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}&hashtag=${postHashtags}`;

    /****************START**********************/
    // Construct the Facebook Sharer URL
    // ###########Existing Logic 1
    // Detect iOS (iPhone / iPad / iPod)
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        
    // On Desktop, opening in a specific popup dimension feels like a native share widget
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    // Use m.facebook.com for iOS, www.facebook.com for Desktop & Android
    const baseUrl = isIOS||isMobile ? 'https://m.facebook.com' : 'https://www.facebook.com';
    //const baseUrl = 'https://www.facebook.com';
    const fbShareDialog = `${baseUrl}/sharer/sharer.php?u=${shareUrl}&hashtag=${postHashtags}`;

    //   // 1. IPHONE / IOS: Try Web Share API First
    // if (isIOS && navigator.share) {
    //     try {
    //         await navigator.share({
    //             title: 'Check this out!',
    //             text: postHashtags, // Passes hashtag string
    //             url: shareUrl       // Passes product URL
    //         });
    //         return; // Successfully opened iOS share sheet
    //     } catch (err) {
    //         // If user explicitly cancels/closes the share sheet, stop execution
    //         if (err.name === 'AbortError') return;
    //         console.warn("Navigator share failed, falling back to browser link:", err);
    //     }
    // }

    if (isIOS||isMobile) {
        // Open directly in a new tab for mobile browsers
        window.open(fbShareDialog, '_blank');
    } else {
        // Center popup window for Desktop (Mac & Windows)
        const width = 600;
        const height = 500;
        const left = (window.innerWidth - width) / 2 + window.screenX;
        const top = (window.innerHeight - height) / 2 + window.screenY;
       
        window.open(
            fbShareDialog,
            'facebook-share-dialog',
            `width=${width},height=${height},top=${top},left=${left},scrollbars=yes`
        );
    }
    /***********END*****************/

    /****************START**********************/
    //########Logic 2:
    // window.open(
    //     `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}&hashtag=${postHashtags}`,
    //     "_blank",
    //     "noopener,noreferrer"
    // );
    /***********END*****************/

    /****************START**********************/
    //######Logic 3:
    // Fallback to standard Facebook popup for Desktop
  // Basic check to see if the user is on a mobile device
    // const isMobile = /iPhone|iPad|iPod|Android|Mobi/i.test(navigator.userAgent);

    // if (isMobile) {
    //   // MOBILE BEHAVIOR:
    //   // Open a clean new tab. The iOS/Android operating system will automatically 
    //   // intercept this URL and launch the Facebook app if it is installed. 
    //   // If not, it safely loads the Facebook mobile website in the new tab.
    //   window.open(shareDialogUrl, '_blank');
    // } else {
    //   // DESKTOP BEHAVIOR: 
    //   // Open the perfectly centered optical popup

    //   const width = 600;
    //   const height = 400;

    //   // Use the screen dimensions instead of the browser viewport
    //   // Get the exact position of the current browser window (dual-monitor safe)
    //   const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    //   const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    //   // Center horizontally perfectly over the parent window
    //   const left = dualScreenLeft + (window.innerWidth / 2) - (width / 2);

    //   // Center vertically, but subtract 100 pixels to nudge it up to the "optical center".
    //   // Math.max(0) ensures the title bar never gets pushed off the top of the monitor.
    //   const calculatedTop = dualScreenTop + (window.innerHeight / 2) - (height / 2) - 100;
    //   const top = Math.max(0, calculatedTop);

    //   window.open(
    //     shareDialogUrl,
    //     'facebook-share-dialog',
    //     `width=${width},height=${height},top=${top},left=${left},toolbar=0,status=0`
    //   );
    // }
    /***********END*****************/

    /****************START**********************/
    //######Logic 4:
    // const width = 600;
    // const height = 400;

    // // Use the screen dimensions instead of the browser viewport
    // // Get the exact position of the current browser window (dual-monitor safe)
    // const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    // const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    // // Center horizontally perfectly over the parent window
    // const left = dualScreenLeft + (window.innerWidth / 2) - (width / 2);

    // // Center vertically, but subtract 100 pixels to nudge it up to the "optical center".
    // // Math.max(0) ensures the title bar never gets pushed off the top of the monitor.
    // const calculatedTop = dualScreenTop + (window.innerHeight / 2) - (height / 2) - 100;
    // const top = Math.max(0, calculatedTop);

    // window.open(
    //   shareDialogUrl,
    //   'facebook-share-dialog',
    //   `width=${width},height=${height},top=${top},left=${left},toolbar=0,status=0`
    // );
    /***********END*****************/


    // Redirect the current window
    //window.location.href = fbShareDialog;
  }



  function downloadImage(url) {
    const img = new Image();
    // This is the magic line. It tells the browser to try and 
    // request the image with permission headers.
    img.crossOrigin = "anonymous";
    img.src = url;

    img.onload = function () {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      // Convert the image to a data URL (a long string of the image data)
      const dataURL = canvas.toDataURL("image/png");

      // Create a link and trigger the download
      const link = document.createElement("a");
      link.href = dataURL;
      link.download = "mydeserve-post.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    img.onerror = function () {
      // If the Canvas trick fails (still blocked by CORS), 
      // we fall back to opening the image in a new tab.
      console.error("Canvas blocked by CORS. Falling back to new tab.");
      window.open(url, "_blank");
    };
  }
  async function downloadImage2(url) {
    try {
      // We wrap the original URL with a proxy service
      const proxiedUrl = `https://cors-anywhere.herokuapp.com/${url}`;
      const response = await fetch(proxiedUrl);
      //const response = await fetch(url, { mode: 'cors' });
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      // Get extension from URL (e.g., "webp", "png", "jpg")
      const extension = product.imageUrl.split(".").pop().split(/\#|\?/)[0] || "jpg";
      link.download = `mydeserve-post.${extension}`;

      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      // If CORS blocks the fetch, fallback to opening in a new tab
      console.error("Download failed, opening in new tab", error);
      window.open(url, '_blank');
    }
  }

  function shareOnInstagram() {
    swalWithBootstrapButtons.fire({
      title: "Auf Instagram teilen",
      html: "Leider kann der Beitrag nicht direkt auf Instagram geteilt werden. Daher findest Du <a id='download-trigger' href='#'>hier</a>" +
        " das <b>Bild</b> für den Post. <b>Lade</b> es <b>herunter</b> und anschliessend wieder als Beitrag auf Instagram <b>hoch</b>.<br />Dabei ist es wichtig <b>#mydeserve</b> in den Posttext zu schreiben. Füge auch eine" +
        " <b>persönliche Nachricht</b> hinzu, um schneller an die Likes zu kommen. Anschliessend ist unter <b>Ort</b> das Unternehmen des Produktes zu hinterlegen.<br />" +
        ' <img src="' + ig2 + '" alt="Produktbild" style="max-width: 100%; height: auto; margin-top: 10px;" />',
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Auf Instagram geteilt",
      cancelButtonText: "Abbrechen",
      didOpen: () => {
        // Add click listener to the link inside the popup
        const downloadBtn = document.getElementById('download-trigger');
        downloadBtn.addEventListener('click', (e) => {
          e.preventDefault();
          downloadImage(product.imageUrl);
        });
      }
    }).then((result) => {
      if (result.isConfirmed) {
        posted("instagram").then(() => {
          window.location.reload();
        });
      }
    });
  }

  function shareOnTikTok() {
    swalWithBootstrapButtons.fire({
      title: "Auf TikTok teilen",
      html: "Leider kann der Beitrag nicht direkt auf TikTok geteilt werden. Daher findest Du <a id='download-trigger' href='#'>hier</a>" +
        " das <b>Bild</b> für den Post. <b>Lade</b> es <b>herunter</b> und anschliessend wieder als Beitrag auf der TikTok App auf dem Smartphone <b>hoch</b>.<br />Dabei ist es wichtig <b>#mydeserve</b> als Hashtag und den <b>Standort</b> des Restaurants zu hinterlegen. Füge auch eine" +
        " <b>persönliche Nachricht</b> hinzu, um schneller an die Likes zu kommen. Weiterführend ist darauf zu achten <b>'Alle können diesen Beitrag sehen'</b> auszuwählen." +
        ' <img src="' + tt2 + '" alt="Produktbild" style="max-width: 100%; height: 500px; margin-top: 10px;" />',
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Auf TikTok geteilt",
      cancelButtonText: "Abbrechen",
      //reverseButtons: true
      didOpen: () => {
        // Add click listener to the link inside the popup
        const downloadBtn = document.getElementById('download-trigger');
        downloadBtn.addEventListener('click', (e) => {
          e.preventDefault();
          downloadImage(product.imageUrl);
        });
      }
    }).then((result) => {
      if (result.isConfirmed) {
        posted("tiktok").then(() => {
          window.location.reload();
        });;
      }
    });
  }

  async function complete() {
    const token = auth0AccessToken;
    await fetch(
      `${serverUrl}/api/deserves/${product.idProduct}/complete`,
      {
        method: METHODTYPE.PUT,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }
};

export default UserProductBox;
